import {Component, Inject, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, FileBlobService,} from '../../_services/index';

import {LoginHelper} from '../../helpers/index';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DocumentRequest} from "../../_models/documentRequest";
import {DocumentRequestService} from "../../_services/documentRequest.service";
import {saveAs as importedSaveAs} from "file-saver";
import {SelectProjectControlItemComponent} from '../selectProjectControlItem/select-project-control-item.component';
import {ActionItemService} from "../../_services/actionItem.service";

@Component({
    standalone: false,
  selector: 'editimplementationcontrolstatementset-component',
  templateUrl: 'editActionItemSet.component.html',
  styleUrls: ['./editActionItemSet.component.scss'],
  providers: [DialogService],
})

export class EditActionItemSetComponent implements OnInit {
  actionPlanSet: any;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditActionItemSetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authenticationService: AuthenticationService,
    public actionItemService: ActionItemService,
    public alertService: AlertService,
    public formBuilder: FormBuilder,
    public dialogService: DialogService) {
  }

  ngOnInit() {
    this.actionPlanSet = this.data.actionPlanSet || {
      name: ''
    };
    this.form = this.formBuilder.group({
      name: ['', Validators.required]
    });
    this.form.setValue({
      name: this.actionPlanSet.name
    });
  }

  onSave() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }

    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.alertService.clear();
    this.actionItemService.saveActionItemSet({name: this.form.value.name, id: this.actionPlanSet.id})
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close(this.actionPlanSet);
  }
}
